$(document).ready(function () {
  function getWorldTime(tzOffset) {
    var now = new Date();
    var tz =
      now.getTime() + now.getTimezoneOffset() * 60000 + tzOffset * 3600000;
    now.setTime(tz);

    var s =
      leadingZeros(now.getFullYear(), 4) +
      "-" +
      leadingZeros(now.getMonth() + 1, 2) +
      "-" +
      leadingZeros(now.getDate(), 2) +
      " " +
      leadingZeros(now.getHours(), 2) +
      ":" +
      leadingZeros(now.getMinutes(), 2) +
      ":" +
      leadingZeros(now.getSeconds(), 2);

    return s;
  }

  function leadingZeros(n, digits) {
    var zero = "";
    n = n.toString();

    if (n.length < digits) {
      for (i = 0; i < digits - n.length; i++) zero += "0";
    }
    return zero + n;
  }

  var now_addr = window.location.href;
  var preview = now_addr.split("?preview=");
  var preview_ = now_addr.split("&preview=");
  
  //rebuy 상세설명 추가
  /*
setTimeout(function() {
  const descriptions = {
    '24/7 Refresh Set': 'Intimate Care Gel (1box) & Foaming Wash (1ea) & Probiotics Powder Mist (1ea)',
    'Balance Care Set': 'Intimate Care Gel (2boxes) & Soothing Cream (1ea) & Intimate Deodorant Spray (1ea)',
    'Cleansing Set': 'Intimate Care Gel (4boxes) & Feminine Wipes (4boxes) & Foaming Wash (1ea)',
    'Total Care Set': 'Intimate Care Gel (3boxes) & Feminine Wipes (2boxes) & Foaming Wash (2ea)',
    'Pure Scent Trio': 'Intimate Care Gel (1box) & Intimate Deodorant Spray (1ea) & Foaming Wash (1ea)',
    '2-Week Care Trio': 'Intimate Care Gel (1box) & Foaming Wash (1ea) & Soothing Cream (1ea)',
    'Natural Fertility Boost': 'Intimate Care Gel (2boxes) & Pleasure Gel (1ea) & Inositol (1box)',
    'Romantic Set': 'Intimate Deodorant Spray (2ea) & Pleasure Gel (2ea)',
    'Care Set': 'Intimate Care Gel (2boxes) & Vaginal Irrigation (5ea)',
    'Essential Set': 'Foaming Wash (1ea) & Pleasure Gel (2ea)',
    'Sanitary Set': 'Foaming Wash (2ea) & Feminine Wipes (4boxes)'
  };

  $('.rebuy-widget .rebuy-product-grid.large-style-list .rebuy-product-block').each(function() {
    const $productInfo = $(this).find('.rebuy-product-info');
    const ariaLabel = $productInfo.find('.rebuy-product-title').attr('aria-label');

    if (ariaLabel) {
      for (const [key, description] of Object.entries(descriptions)) {
        if (ariaLabel.includes(key)) {
          $productInfo.find('.rebuy-product-price')
            .after(`<p class="rbuy_info" style="margin-top:20px;">${description}</p>`);
          break;
        }
      }
    }
  });
}, 2000);
*/


// 260714 세트상품 6종 ( Essentials/Usage 문구 수정 및 상세페이지 수정) 
const targetUrls = [
    '/products/foam-repair-duo',
    '/products/foam-moisture-duo-copy',
    '/products/foam-refresh-duo',
    '/products/4-way-complete-gel-set',
    '/products/intimate-balance-moisture-duo',
    '/products/intimate-balance-refresh-duo',
    '/products/cool-clean-wash-duo',
    '/products/cool-balance-duo'
];

if ($('#ProductInfo-template--27572105937186__main, #ProductInfo-template--27572128350498__main, #ProductInfo-template--27572128383266__main').length) {
    $('.product_detail_slide').css('max-width', 'none');
}

const isTargetProduct = targetUrls.some(url =>
    $(`[data-url="${url}"]`).length
);
const matchedUrl = targetUrls.find(url => $(`[data-url="${url}"]`).length);

if (isTargetProduct) {
  const waitForElement = (selector, callback, maxTry = 20) => {
    let tries = 0;
    const timer = setInterval(() => {
      const $el = $(selector);
      tries++;
      if ($el.length) {
        clearInterval(timer);
        callback($el);
      } else if (tries >= maxTry) {
        clearInterval(timer);
        console.warn('요소를 찾지 못했습니다:', selector);
      }
    }, 200);
  };

  waitForElement('.product__accordion.accordion[rel="The Essentials Explained"]', ($accordion) => {
    const setPrdNameArr = $accordion.find('.set_item_exp .if_you')
      .map((i, el) => $(el).text().trim())
      .get();
    console.log('setPrdNameArr=', setPrdNameArr);

    $accordion.find('.set_item_exp').each((i, el) => {
      const $item = $(el);
      const name = $item.find('.if_you').text().trim();

      if (name === 'Intimate Refresh Gel') {
        $item.find('span:last-child').text('A pineapple extract gel that helps with intimate odor, freshness, and pH imbalance.');
      }
      if(name === 'Intimate Moisture Gel'){
        $item.find('span:last-child').text('A Hyaluronic Acid-based gel for multi-layer hydration and dryness management.');
      }
      if(name === 'Foaming Wash'){
        $item.find('span:last-child').text('Probiotic micro-foam that cleanses intimate odor and hydrates dry skin.');
      }
    });
  });

  waitForElement('.product__accordion.accordion[rel="Recommended Usage"]', ($accordion) => {
    const excludedUrls = ['/products/cool-clean-wash-duo', '/products/cool-balance-duo'];

    if (matchedUrl === '/products/cool-balance-duo') {
      $accordion.find('.set_item_usage').each((i, el) => {
        const $item = $(el);
        const name = $item.find('.if_you').text().trim();

        if (name === 'Intimate Care Gel for Women') {
          $item.find('.usage .metafield-rich_text_field p').html('Restore balance <strong>after wash</strong>');
        }
      });
    }

    if (excludedUrls.includes(matchedUrl)) return;

    const setPrdNameArr = $accordion.find('.set_item_usage .if_you')
      .map((i, el) => $(el).text().trim())
      .get();
    console.log('setPrdNameArr=', setPrdNameArr);

    $accordion.find('.set_item_usage').each((i, el) => {
      const $item = $(el);
      $item.hide();
    });
});
}
// [E] 260714 세트상품 6종 ( Essentials/Usage 문구 수정 및 상세페이지 수정) 


 // 251107 이너케어젤 공지 컬러
 if ($(".product__info-wrapper").length > 0) {
   if ($('[data-url="/products/intimate-care-gel-for-women"]').length > 0) {

    $('div.product__text').eq(1).find('.custom_detail').addClass('lato');
    $('div.product__text').eq(1).find('.custom_detail').css({'color':'red','margin-bottom':'15px', 'font-size':'14px'});
    $('div.product__text').eq(1).find('.custom_detail > *').css({'font-family':'inherit'});
    $('div.product__text').eq(1).find('.custom_detail > * > strong').css({'font-weight':'600'});
    

     /*
     $(".product__info-container").after(
       '<div id="ic_notice" class="fs14" style="margin-top:45px; line-height:1.4; color:#000"></div>'
     );
     */
   } 
   /*
   $("#ic_notice").html(
     "<strong class='fs22' style='font-weight:700'>Shipping Update</strong><br/><br/>Due to the ongoing wildfires in California, some orders may experience shipping delays. <br/>We apologize for any inconvenience and appreciate your understanding during this time."
   );
   */
 }

  // free_badge 추가
  /*
  $(".card--media .card__inner .card__content").prepend(
    '<span class="free_bd">FREE GIFT</span>'
  );
  $(".free_bd").css("display", "none");
*/
  // 노출할 ID 목록
  var ids = [
    "#title-template--22592406683938__product-grid-9447426425122",
    "#title-template--22592406683938__product-grid-8719291384098",
    "#title-template--22592406683938__product-grid-8719285059874",
    "#title-template--22592406683938__product-grid-8807224148258",
    "#title-template--22592407470370__featured_collection-8719291384098",
  ];

  ids.forEach(function (id) {
    $(id)
      .parents(".grid__item")
      .find(".card--media .card__inner .card__content .free_bd")
      .css("display", "block");
  });

  $("#ProductInfo-template--23694844494114__main").after("<span></span>");

  //rebuy 앱이 있을 경우 해당 컨텐츠 수정
  setTimeout(function () {
      if ($('#rebuy-widget-193614').length && !$('.rebuy_link').length) {
          $('#rebuy-widget-193614 .rebuy-product-info').append('<a href="#" class="rebuy_link">Learn More</a>');
  
          $('#rebuy-widget-193614 .rebuy-product-info').on('click', '.rebuy_link', function (event) {
              event.preventDefault();
  
              $(this).closest('.rebuy-product-info').find('.rebuy-product-title')[0].click();
          });
      }
  }, 2000);


// CVS
let cvsPromotion = (getWorldTime(+9) > "2026-06-12 16:00:00") || preview[1] == "cvs" || preview[1] == "cvs_only" ;

if(cvsPromotion){
  var rel = $('.product__title h1').attr('rel');

  $('.badge--cvs, .cvs_promotion').removeClass('displaynone');
  if ($(".product .product__title").length > 0 && $('.badge--cvs').length > 0) {

    if(!(rel == '8462415135010' || rel == '8719291384098' || rel == '8269912801570' || rel == '10440356331810' || rel == '10440355971362')){
      $('.product_detail_visual').prepend('<img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/cvs_detail_PC.jpg?v=1780991508" class="only_pc cvcBnr"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/cvs_detail_MO.jpg?v=1780991507" class="only_mo cvcBnr">');
    }

    if(rel == "10373111447842" || rel == "10447760851234" || rel == "10447759343906"){
      $('.detail-hero').before('<div class="cvcWrap"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/cvs_detail_PC.jpg?v=1780991508" class="only_pc cvcBnr"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/cvs_detail_MO.jpg?v=1780991507" class="only_mo cvcBnr"></div>');
    }
  }

  // 미드서머 2개 제품 cvsBtnWrapper 삭제
  if(rel == '10440356331810' || rel == '10440355971362'){
    $('.cvsBtnWrapper').hide();
  }

}else{
  $('.badge--cvs, .cvs_promotion').remove();
}
// -- [E] CVS



// 재고 부족/배송 지연 안내 문구
if(getWorldTime(+9) > "2026-10-24 16:00:00" && ($('.product__title h1[rel="8845718323490"]').length || $('.product__title h1[rel="8719291384098"]').length) || now_addr.includes('soldoutPreview')) {
  $('.product-form__buttons').before(`
    <p style="margin-bottom: 20px; font-size: 15px; color: #f00;">Please note: Aqua Bloom & Sweet Berry Intimate Deodorant Spray may arrive in updated packaging.
The packaging may look different, but the product itself remains the same. Thank you for your understanding.</p>
  `)
}
if($('.product__title h1[rel="10152274985250"]').length || $('.product__title h1[rel="10316223480098"]').length || $('.product__title h1[rel="10316141855010"]').length || $('.product__title h1[rel="10316224921890"]').length) {
  $('.product-form__buttons').before(`
    <p style="margin-bottom: 20px; font-size: 15px; color: #f00;">Please note: Orders containing Intimate Refresh Gel may experience a 7+ day delay due to temporary low stock. Thank you for your understanding!</p>
  `)
}

// 프로모션 js start
var promotionEvent = (getWorldTime(+9) > "2026-10-30 16:00:00" && getWorldTime(+9) < "2026-11-04 16:00:00") || ( window.location.href.includes('preview=promotion') && typeof preview !== "undefined" && !(preview[1] == "cvs") && !(preview[1] == "cvs_only"));

if (promotionEvent) {
  /* 메인 슬라이드: 프로모션 슬라이드 보이게 */
   if ($('.main_slide').length > 0) {

     $('.main_slide .swiper-slide.prmBannerHide').show();
     $('.main_slide .swiper-slide.prmFavorites').remove();
     $('.main_slide .swiper-slide.prmBannerHide').removeClass('displaynone');

     if (typeof main_bnr !== "undefined") {
       main_bnr.updateSlides();
       main_bnr.update();
     }
   }

  // 띠문구 추가 (에디터에서 문안변경)
  $('.announcement-bar').addClass('prm');
  $('.prm_topBnr').removeClass('displaynone');

  // 상세페이지 이미지 삽입
   if ($('.product .product__title').length > 0) {
     if ($('.bundle-promo-banner').length > 0) {
       $('.bundle-promo-banner').before(
         '<div class="prmBanner prmBundle">'+
         '<a href="https://lactomedi.com/collections/all" style="margin-bottom:20px;"><img style="width:100%;" src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/halloween_detail.jpg?v=1792735582" class="only_pc"></a>' +
         '<a href="https://lactomedi.com/collections/all" style="margin-bottom:20px;"><img style="width:100%;" src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/halloween_detail_MO.jpg?v=1792735581" class="only_mo"></a>' +
         '</div>'
       );
     } else if ($('.product_set_info').length > 0) {
       $('.product_set_info').before(
         '<div class="prmBanner">'+
         '<a href="https://lactomedi.com/collections/all" style="margin-bottom:20px;"><img style="width:100%;" src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/halloween_detail.jpg?v=1792735582" class="only_pc"></a>' +
         '<a href="https://lactomedi.com/collections/all" style="margin-bottom:20px;"><img style="width:100%;" src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/halloween_detail_MO.jpg?v=1792735581" class="only_mo"></a>' +
         '</div>'
       );
     } else {
       $('.product_detail_visual').prepend(
         '<div class="prmBanner">'+
         '<a href="https://lactomedi.com/collections/all" style="margin-bottom:20px;"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/halloween_detail.jpg?v=1792735582" class="only_pc"></a>' +
         '<a href="https://lactomedi.com/collections/all" style="margin-bottom:20px;"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/halloween_detail_MO.jpg?v=1792735581" class="only_mo"></a>' +
         '</div>'
       );
     }
   }
}else{
  $('.main_slide .swiper-slide.prmBannerHide').remove();
}
// 프로모션 js end



// PRICE DOWN 뱃지 추가 (260613 - 260620)
if (preview[1] == "cvs" || (getWorldTime(+9) > "2026-06-12 16:00:00" && getWorldTime(+9) < "2026-06-19 15:59:59")) { //CVS 배너 노출과 기간 겹쳐서 확인용
  $('.thumb_badge.badge--sale').removeClass('displaynone');
  $('.gallery-top .badge--new--cicle.badge--sale').removeClass('displaynone');

  // 메인 슬라이드 변경
  $('.main_slide .swiper-slide.prmFavorites').show(); 
  $('.main_slide .swiper-slide.prmFavorites').removeClass('displaynone');

  if (typeof main_bnr !== "undefined") {
    main_bnr.updateSlides();
    main_bnr.update();
  }

}

//BV-Killer gel 장바구니 - 추천 숨김처리
if($('.product__title h1').attr('rel') == 9840391684386){
  setTimeout(()=>{
    $("#rebuy-cart .rebuy-cart__flyout-recommendations").hide();
  },2000);

  $('.header.page-width').attr('style','position: static !important');
  $(".header__heading-link").css({"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%,-50%)"});

  const newStyle = document.createElement('style');
  const cssRules = `@media (max-width: 990px) {.header.page-width .header__heading-link{margin:0 !important;}}`;
  newStyle.textContent = cssRules;
  document.head.appendChild(newStyle);
}

  // if (
  //   (getWorldTime(+9) > "2025-03-14 17:00:00" &&
  //     getWorldTime(+9) < "2025-03-23 17:00:00") 
  // ) {
  //   /* header design */
  //   // $(".focus-none").css("transform", "translateY(0)");
  //   $(".main_slide.promotion_vis.carousel").hide();
  //   // $(".main_slide.promotion_vis.review_bnr").hide();
  //   $(".main_slide.promotion_vis.trialkit_bnr").hide();

  //   //header 변경
  //   function checkMenuStatus() {
  //     if (window.matchMedia('(max-width: 990px)').matches) {
  //       $('sticky-header,.header.page-width').css('background', 'transparent');
  //       $('#MainContent').css('transform', 'translateY(-60px)');
    
  //       function updateHeaderBackground() {
  //         let windowTop = $(window).scrollTop();
    
  //         if ($('.menu-drawer-container').hasClass('menu-opening')) {
  //           $('sticky-header, .header.page-width').css('background', '#fff');
  //         } else {
  //           $('sticky-header, .header.page-width').css('background', 'transparent');
  //         }
  //       }
    
  //       $(window).on('scroll', updateHeaderBackground);
  //       setInterval(updateHeaderBackground, 500);
  //     }
  //   }
  //   //checkMenuStatus();
  //   //$(window).resize(checkMenuStatus);
    
  //   //header 변경 end
    
  //   $(".free_bd").hide();

  //   // $(".main_slide.promotion_vis.second_bnr").before(
  //   //   '<div class="promotion_vis main_prm black"><a href="/collections/shop-all"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/PC.webp?v=1741237304" class="promotion_pc"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/MO.webp?v=1741237304" class="promotion_mo"></a></div>'
  //   // );
    
  //   // 단품 상세페이지
  //   $(".normal_tab, .detail_set").before(
  //     '<div class="promotion_vis"><a href="/collections/shop-all"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/trail_250313_pc.webp?v=1741839373" class="promotion_pc"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/trail_250313_mo.webp?v=1741839372" class="promotion_mo"></a></div>'
  //   );
    
  //   // 셋트 상세페이지
  //   if ($(".normal_tab, .detail_set").length === 0) {
  //     $(".detail_normal_video.new, .cleansing_set_bnr").before(
  //       '<div class="promotion_vis"><a href="/collections/shop-all"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/trail_250313_pc.webp?v=1741839373" class="promotion_pc"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/trail_250313_mo.webp?v=1741839372" class="promotion_mo"></a></div>'
  //     );
  //   }
    
  //   // 클렌징세트 상세페이지
  //   if ($("#shopify-section-template--23694843085090__main_slide_CBa8Yz").length) {
  //     $(".normal_tab, .main_slide.promotion_vis.main_prm").before(
  //       '<div class="promotion_vis" style="z-index:1;"><a href="/collections/shop-all"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/trail_250313_pc.webp?v=1741839373" class="promotion_pc"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/trail_250313_mo.webp?v=1741839372" class="promotion_mo"></a></div>'
  //     );
  //   }

  //   $(".promotion_vis.dual").removeClass("displaynone");
  //   $(".promotion_hidden").remove();
  //   $(".promotion_bar_friend").remove();
  //   $(".promotion_bar_dual").show();
  //   $(".promotion_women").removeClass("displaynone");
  // } else {
  //   // $(".main_slide.promotion_vis").hide();
  //   //$(".focus-none").css("transform", "translateY(-74px)");
  //   $(".main_vis").before(
  //     '<div class="promotion_vis main_prm"><a href="https://lactomedi.com/products/intimate-care-gel-for-women"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/PC_19afa081-8d29-4f92-8fdc-966a36a9e4cd.png?v=1716851621" class="promotion_pc"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/MO_138e474b-1c5d-4623-9b6b-e19534820278.png?v=1716851622" class="promotion_mo"></a></div>'
  //   );
  //   // $(".main_slide .prm").remove();
  //   $(".promotion_bar_event").remove();
  //   $(".promotion_hidden").remove();
  //   $(".promotion_women").remove();
  //   $(".main_slide.promotion_vis.trialkit_bnr").show();
  // }

  // 이너케어젤 Hidden LInk
  $(
    ".product-grid-container #product-grid .grid__item #title-template--22592406683938__product-grid-9506158248226"
  )
    .parents(".card-wrapper")
    .css("display", "none");
  $(
    ".template-search .product-grid-container #product-grid .grid__item #CardLink--9506158248226"
  )
    .parents(".grid__item")
    .remove();

  if (
    getWorldTime(+9) > "2024-10-20 16:00:00" ||
    preview[1] == "hidden" ||
    preview_[1] == "hidden"
  ) {
    if ($("#shopify-section-template--23583669715234__main").length > 0) {
      console.log("hidden link");
      $(
        ".gallery-top .swiper-button-next,.gallery-top .swiper-button-prev"
      ).hide();

      $(".promotion_dual").remove();
      $(".promotion_bar_friend").remove();
      $(".promotion_hidden")
        .removeClass("displaynone")
        .find("p span")
        .css("color", "#fff");
      $(".announcement-bar").css("background", "#f00");
      $(".product__title h1").before(
        '<span class="fs36 dm hidden_title">🤫Hidden Discount🔒</span>'
      );
      $(".header.page-width .header__icons .header__search").css(
        "display",
        "none"
      );

      // 제품 그리드 앞에 세일 배너 추가
      $("#MainContent").before(
        '<div class="time_sale_bnr"><p class="top_text">⏳Hurry! The sale is about to end⏳<br/>Limited Stock Available: <span class="stock">589</span></p><p class="time-area"><span class="time-part"><span class="digit">0</span><span class="digit">0</span></span>:<span class="time-part"><span class="digit">0</span><span class="digit">0</span></span>:<span class="time-part"><span class="digit">0</span><span class="digit">0</span></span></p><span class="bot_text">*Regular price applies after the sale.</span></div>'
      );

      // 초기 stock 값 설정
      let stock = 589;

      // stock 값을 5초마다 2씩 감소시키는 타이머
      let stockTimer = setInterval(() => {
        if (stock > 0) {
          stock -= 2;
          $(".stock").text(stock);
        } else {
          clearInterval(stockTimer); // stock이 0 이하가 되면 타이머 멈춤
        }
      }, 60 * 1000);

      // 특정 종료 시간을 설정 (예: 현재 시간으로부터 1시간 17분 후)
      let endTime = new Date(Date.now() + 1 * 60 * 60 * 1000 + 17 * 60 * 1000); // 1시간 + 17분
      let countdownTimer = setInterval(() => {
        let now = new Date(); // 현재 시간
        let remainingTime = endTime - now; // 남은 시간 (밀리초 단위)

        // 남은 시간이 0보다 클 경우 계산
        if (remainingTime > 0) {
          let hours = Math.floor((remainingTime / (1000 * 60 * 60)) % 24);
          let minutes = Math.floor((remainingTime / (1000 * 60)) % 60);
          let seconds = Math.floor((remainingTime / 1000) % 60);

          // 각 시간, 분, 초를 업데이트
          $(".time-part")
            .eq(0)
            .find(".digit")
            .eq(0)
            .text(String(hours).padStart(2, "0")[0]); 
          $(".time-part")
            .eq(0)
            .find(".digit")
            .eq(1)
            .text(String(hours).padStart(2, "0")[1]); 
          $(".time-part")
            .eq(1)
            .find(".digit")
            .eq(0)
            .text(String(minutes).padStart(2, "0")[0]); 
          $(".time-part")
            .eq(1)
            .find(".digit")
            .eq(1)
            .text(String(minutes).padStart(2, "0")[1]); 
          $(".time-part")
            .eq(2)
            .find(".digit")
            .eq(0)
            .text(String(seconds).padStart(2, "0")[0]); 
          $(".time-part")
            .eq(2)
            .find(".digit")
            .eq(1)
            .text(String(seconds).padStart(2, "0")[1]); 
        } else {
          clearInterval(countdownTimer);
          $(".time_sale_bnr").remove();
          clearInterval(stockTimer);
        }
      }, 1000);
    }
  }

  // delay
  if (
    (getWorldTime(+9) > "2025-10-14 10:00:00" &&
      getWorldTime(+9) < "2025-10-22 00:00:00") ||
    preview[1] == "delay" ||
    preview_[1] == "delay"
  ) {
    var prmPdArr = [
      8269912801570, 8269908869410, 8269925220642, 8845718323490, 9447446053154, 8845702365474
    ];
    for (var i = 0; i <= prmPdArr.length - 1; i++) {
      if ($(".product__title h1").attr("rel") == prmPdArr[i]) {
        $(".product__info-container").after(
          '<div id="ic_notice" class="fs16" style="margin-top:15px; line-height:1.4; color:red"></div>'
        );
        $("#ic_notice").html(
          "🚨 Thank you for your amazing support!<br/>Due to an unexpected surge in demand, some of our items are temporarily out of stock. We apologize for the inconvenience and appreciate your patience as we restock."
        );
      }
    }
  }

  if ($(".buy_btn + .product__text").length > 0) {
    if (getWorldTime(+9) < "2023-11-09 16:00:00") {
      $(".buy_btn + .product__text").show();
      $(".buy_btn + .product__text .custom_detail")
        .removeClass("fs20")
        .addClass("fs16");
    } else {
      $(".buy_btn + .product__text").remove();
    }
  }
});
